import React, { useState, useEffect, useRef } from 'react';

import { Loader } from '../../misc/loader-utils';

import smallX from '../../../images/icons/X-small.png';
import blueX from '../../../images/icons/icon-cancel-small.svg';
import './styles/search-bar.scss';
import { useDebounce, useOutsideClick } from '../../../utils/custom-hooks';

const SearchBar = ({
  setSearchQuery,
  placeholder,
  searchTerm,
  setSearchTerm,
  loading,
  loadingSpinner,
  xIcon,
  blueXIcon,
}) => {
  const searchBar = useRef(false);

  const [focus, setFocus] = useState(false);

  const debouncedSearch = useDebounce(searchTerm, 600);
  useOutsideClick(searchBar, () => setFocus(false));

  useEffect(() => {
    setSearchQuery(debouncedSearch);
  }, [debouncedSearch]);

  const spinner = loadingSpinner ? <Loader loading={loading} /> : null;

  const xButton =
    (blueXIcon || (xIcon && !loading)) && searchTerm ? (
      <img
        src={blueXIcon ? blueX : smallX}
        className="x-icon"
        alt="clear"
        onClick={() => setSearchTerm('')}
      />
    ) : null;

  return (
    <div
      className={`text-search-bar ${focus ? 'focus' : ''}`}
      ref={node => (searchBar.current = node)}
      onClick={() => setFocus(true)}
    >
      <div className="search-icon"></div>
      <input
        value={searchTerm}
        onChange={event => setSearchTerm(event.target.value)}
        placeholder={placeholder}
        className="search-bar-input"
      />
      {spinner}
      {xButton}
    </div>
  );
};

export default SearchBar;
